import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Container, Card, Button, Table } from 'react-bootstrap';

const CaseStudyReport = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { results, totalQuestions, caseStudyId } = location.state || { results: [], totalQuestions: 0, caseStudyId: null };

  if (!results || !results.length) {
    return (
      <Container className="mt-5 text-center">
        <p>No case study data available.</p>
        <Button variant="outline-primary" onClick={() => navigate('/dashboard')}>
          Back to Dashboard
        </Button>
      </Container>
    );
  }

  const totalScore = results.reduce((sum, r) => sum + r.score, 0);
  const maxPossibleScore = results.reduce((sum, r) => {
    const max = r.mode === 'MC' ? 1 : r.mode === 'SATA' ? r.correct_answer.split(',').length : r.mode === 'MATRIX' ? r.correct_answer.split(',').length : 1;
    return sum + max;
  }, 0);
  const percentCorrect = maxPossibleScore > 0 ? ((totalScore / maxPossibleScore) * 100).toFixed(1) : 0;

  return (
    <Container className="mt-4" style={{ maxWidth: '900px' }}>
      <h2 className="mb-3">Case Study Report</h2>
      <Card className="mb-4">
        <Card.Body>
          <Card.Title>Overall Performance</Card.Title>
          <Table bordered>
            <tbody>
              <tr><td><strong>Total Questions</strong></td><td>{totalQuestions}</td></tr>
              <tr><td><strong>Questions Answered</strong></td><td>{results.length}</td></tr>
              <tr><td><strong>Total Score</strong></td><td>{totalScore} / {maxPossibleScore} ({percentCorrect}%)</td></tr>
            </tbody>
          </Table>
        </Card.Body>
      </Card>

      <Card>
        <Card.Body>
          <Card.Title>Question Details</Card.Title>
          <Table striped bordered hover>
            <thead>
              <tr><th>#</th><th>Your Answer</th><th>Correct Answer</th><th>Score</th></tr>
            </thead>
            <tbody>
              {results.map((r, idx) => (
                <tr
                  key={idx}
                  onClick={() => navigate(`/case-study/review/${caseStudyId}`, { state: { startIndex: idx } })}
                  style={{ cursor: 'pointer' }}
                >
                  <td>{idx + 1}</td>
                  <td>{r.selected || '(none)'}</td>
                  <td>{r.correct_answer}</td>
                  <td>{r.score}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Card.Body>
      </Card>

      <div className="mt-3 text-center">
        <Button
          variant="outline-primary"
          onClick={() => navigate(`/case-study/review/${caseStudyId}`, { state: { startIndex: 0 } })}
          className="me-2"
        >
          Review Answers
        </Button>
        <Button variant="primary" onClick={() => navigate('/dashboard')}>
          Back to Dashboard
        </Button>
      </div>
    </Container>
  );
};

export default CaseStudyReport;